<div id="merchant-overview-wrapper" data-cy="merchant-overview-wrapper">
  <p *ngIf="notFound" data-cy="merchant-not-found">Merchant not found.</p>

  <p-card *ngIf="merchant && !notFound" class="merchant-overview-form-card" data-cy="merchant-overview-form-card">
    <ng-template pTemplate="header">
      <div id="merchant-overview-form-card-header">
        <h1>{{ merchant.Name }}</h1>

        <ng-container *ngIf="(mode$ | async) === 'view'">
          <div class="merchant-overview-form-card-header-view-actions">
            <p-button
              (onClick)="edit()"
              icon="pi pi-file-edit"
              label="Edit"
              size="large"
              id="edit-merchant-overview-button"
              data-cy="edit-merchant-overview"
            ></p-button>
          </div>
        </ng-container>
        <div *ngIf="(mode$ | async) === 'edit'" class="merchant-overview-form-card-header-edit-actions">
          <p-button
            (onClick)="cancelEdit()"
            [disabled]="isSaving"
            icon="pi pi-ban"
            label="Cancel"
            size="large"
            id="cancel-edit-merchant-overview-button"
            data-cy="cancel-edit-merchant-overview"
          ></p-button>
          <p-button
            (onClick)="saveMerchant()"
            [disabled]="(isSaveDisabled$ | async) === true || isSaving"
            [loading]="isSaving"
            icon="pi pi-check-square"
            label="Save"
            size="large"
            id="save-merchant-overview-button"
            data-cy="save-merchant-overview"
          ></p-button>
        </div>
      </div>
    </ng-template>

    <app-merchant-overview-form [merchant]="merchant" [representatives]="representatives"></app-merchant-overview-form>
  </p-card>
</div>
